module.exports = __webpack_public_path__ + "img/GroupN3.f73fb2bf.png";